import React, { useEffect, useState } from "react";
import "./Style.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Assets/Trash_Full.png";
import selectedstar from "../../../Assets/book-red.png";
import unselectedstar from "../../../Assets/book-white.png";
import {
  APIUrlOne,
  APIUrlThree,
  APIUrlToken,
  GetUserId,
} from "../../../Utils/Utils";
import { AI_PROFILE_FORM_TABLE } from "../../../Utils/Constants";
import axios from "axios";
import Loader from "../../Loader/Loader";
import { toast } from "react-toastify";
import moment from "moment";
import greypencil from "../../../Assets/greypencil.png";
import privateLock from "../../../Assets/grey-lock.png";
import * as XLSX from "xlsx";
import { Box, IconButton, Typography } from "@mui/material";
export default function LeadsSharedProfileTable({
  setRefState,
  isDecisionMakerExcel,
  setIsDecisionMakerExcel,
  shareRecord,
  setShareRecord,
  isMobile,
  isTabletPortrait,
}) {
  const navigate = useNavigate();
  const loggedInUserId = GetUserId();
  const [selectedStar, setSelectedStar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [leadsProfileData, setLeadsProfileData] = useState([]);
  const [selectedOuterRows, setSelectedOuterRows] = React.useState([]);
  const [rowsSelectAll, setRowsSelectAll] = React.useState(false);
  const [isLeadProfile, setIsLeadProfile] = useState(false);
  const userId = GetUserId();
  const handleStarClick = (item) => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/set_default_org_filter?name=${item.name}&user_id=${loggedInUserId}`,
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        if (response?.status === 200) {
          setRefState(true);
          setSelectedStar(item?.key === selectedStar ? null : item?.key);
          toast.success(response?.data?.message);
          LeadsProfile();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  const LeadsProfile = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_public_filter_org`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          let data = e?.data?.data
            ? [...e.data.data].sort((a, b) => {
                if (a.default && !b.default) return -1;
                if (!a.default && b.default) return 1;
                return b.id - a.id;
              })
            : [];
          setLeadsProfileData(data);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (userId && isLeadProfile) {
      LeadsProfile();
    } else setIsLeadProfile(true);
  }, [userId, isLeadProfile]);
  const handleRowSelect = (row) => {
    setSelectedOuterRows((prevSelectedRows) => {
      const isAlreadySelected = prevSelectedRows.some(
        (item) => item.id === row.id,
      );
      if (isAlreadySelected) {
        return prevSelectedRows.filter((item) => item.id !== row.id);
      } else {
        return [...prevSelectedRows, row];
      }
    });
  };
  React.useEffect(() => {
    if (rowsSelectAll) {
      const allRows = [...leadsProfileData];
      setSelectedOuterRows(allRows);
    } else if (rowsSelectAll === false) {
      setSelectedOuterRows([]);
    } else if (selectedOuterRows?.length == leadsProfileData?.length) {
      setRowsSelectAll(true);
    } else if (selectedOuterRows?.length < leadsProfileData?.length) {
      setRowsSelectAll(false);
    }
  }, [rowsSelectAll]);
  const exportToExcel = (data, filename) => {
    const filteredData = data.map(
      ({ person_id, org_id, strengthData, ...rest }) => rest,
    );
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${filename}.xlsx`);
    setIsDecisionMakerExcel(false);
    setSelectedOuterRows([]);
    setRowsSelectAll(false);
  };
  React.useEffect(() => {
    if (isDecisionMakerExcel) {
      if (!selectedOuterRows?.length) {
        toast.error("Please select records to download");
        setIsDecisionMakerExcel(false);
        return;
      }
      exportToExcel(selectedOuterRows, "aiprofile_exported_data");
    }
  }, [isDecisionMakerExcel]);
  React.useEffect(() => {
    if (shareRecord) {
      let filter = selectedOuterRows.find((i) => i.public == false);
      if (!selectedOuterRows?.length) {
        toast.error("Please select records to share");
        setShareRecord(false);
        return;
      } else if (filter) {
        toast.error("Please select only public records to share");
        setShareRecord(false);
        return;
      }
      handleShare();
    }
  }, [shareRecord]);
  const handleShare = () => {
    let start = window.location.origin;
    let end = window.location.pathname?.split("/");
    let href = `${start}/${end[1]}/${2}`;
    const subject = encodeURIComponent(`Link to AI Lead Profile`);
    let profilesInfo = selectedOuterRows
      .map(
        (row) =>
          `Profile Name: ${row?.name}\nCreated At: ${moment(row?.created_at).format("YYYY-MM-DD")}\nOwner: ${row?.username ? row?.username : ""}`,
      )
      .join("\n\n");
    const body = encodeURIComponent(
      `Hello,\n\nHere’s an AI Profile on JOI that you may find interesting:\n\n${profilesInfo}\n\nTo view it, log into your JOI account and navigate to AI Profile and go to the shared profiles: ${href}`,
    );
    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=${subject}&body=${body}`;
    window.open(gmailLink, "_blank");
    setSelectedOuterRows([]);
    setRowsSelectAll(false);
    setShareRecord(false);
  };

  const labelStyle = {
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 400,
    color: "#6B7280",
  };

  const valueStyle = {
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 500,
    color: "#111827",
  };

  return (
    <>
      {loading ? <Loader /> : null}
      {isMobile ? (
        leadsProfileData.length > 0 ? (
          <Table>
            <p
              style={{
                fontFamily: "Inter",
                fontWeight: "600",
                fontStyle: "Semi Bold",
                fontSize: "18px",
                backgroundColor: "#F3F4F9",
                paddingBottom: "5px",
              }}
            >
              Shared Lead Profiles
            </p>

            <TableBody>
              {leadsProfileData?.map((item, index) => (
                <TableRow
                  style={{ textAlign: "left", backgroundColor: "#F3F4F9" }}
                  key={item.key}
                >
                  {" "}
                  <Box
                    sx={{
                      border: "1px solid #E2E8F0",
                      borderRadius: "10px",
                      padding: "10px",
                      backgroundColor: "#fff",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    {/* Title */}
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: 700,
                        fontSize: "16px",
                        color: "#111827",
                        cursor: "pointer",
                        textAlign: "left",
                        fontStyle: "bold",
                      }}
                      onClick={() =>
                        navigate(AI_PROFILE_FORM_TABLE, {
                          state: { data: item, disableFields: true },
                        })
                      }
                    >
                      {item?.name || "-"}
                    </Typography>

                    {/* Created On + Privacy */}
                    <Box sx={{ display: "flex", gap: "40px" }}>
                      <Box>
                        <Typography sx={labelStyle}>Created On</Typography>
                        <Typography sx={valueStyle}>
                          {moment(item?.created_at).format("YYYY-MM-DD")}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography sx={labelStyle}>Privacy Status</Typography>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <div className="privacy-status-tr">
                            <h3 className="annual-revenue-table">
                              {" "}
                              {item?.public === false ? "Private" : "Public"}
                            </h3>
                            <img
                              src={privateLock}
                              className="img-lock"
                              alt="My Lists"
                            />
                          </div>
                        </Box>
                      </Box>
                    </Box>

                    {/* Owner */}
                    <Box
                      sx={{
                        textAlign: "left",
                      }}
                    >
                      <Typography sx={labelStyle}>Owner</Typography>
                      <Typography sx={valueStyle}>
                        {item?.username || "-"}
                      </Typography>
                    </Box>

                    {/* Actions */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        mt: "4px",
                      }}
                    >
                      <span className="threeDotIcon-table-profile">
                        <img src={Delete} alt="" />
                      </span>
                      <span
                        className="threeDotIcon-table-profile"
                        onClick={() => handleStarClick(item)}
                      >
                        {item?.default ? (
                          <img src={selectedstar} alt="" />
                        ) : (
                          <img src={unselectedstar} alt="" />
                        )}
                      </span>
                      <span className="threeDotIcon-table-profile">
                        <img src={greypencil} alt="" />
                      </span>
                    </Box>
                  </Box>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className="ai-leads-table-main">
            <div className="ai-leads-no-data-available-outter">
              <div className="ai-leads-no-data-available">
                No Data Available
              </div>
            </div>
          </div>
        )
      ) : isTabletPortrait ? (
        leadsProfileData.length > 0 ? (
          <Table>
            <p
              style={{
                fontFamily: "Inter",
                fontWeight: "600",
                fontStyle: "Semi Bold",
                fontSize: "18px",
                paddingBottom: "5px",
                backgroundColor: "#F3F4F9",
             
              }}
            >
              Shared Lead Profiles
            </p>

            <TableBody>
              {leadsProfileData?.map((item, index) => (
                <TableRow
                  style={{ textAlign: "left", backgroundColor: "#F3F4F9" }}
                  key={item.key}
                >
                  {" "}
                  <Box
                    sx={{
                      border: "1px solid #E2E8F0",
                      borderRadius: "10px",
                      padding: "10px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      marginBottom: "10px",
                         background: selectedOuterRows?.some((i) => i.id === item?.id)
                  ? "#c0dae6"
                  : "#fff",
                      // backgroundColor: "#fff",
                    }}
                  >
                    {/* Title */}
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: 700,
                        fontSize: "16px",
                        color: "#111827",
                        cursor: "pointer",
                        textAlign: "left",
                        fontStyle: "bold",
                      }}
                      onClick={() => handleRowSelect(item)}
                      // onClick={() =>
                      //   navigate(AI_PROFILE_FORM_TABLE, {
                      //     state: { data: item, disableFields: true },
                      //   })
                      // }
                    >
                      {item?.name || "-"}
                    </Typography>

                    {/* Created On + Privacy */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: "40px",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>
                        <Typography sx={labelStyle}>Created On</Typography>
                        <Typography sx={valueStyle}>
                          {moment(item?.created_at).format("YYYY-MM-DD")}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography sx={labelStyle}>Privacy Status</Typography>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <div className="privacy-status-tr">
                            <h3 className="annual-revenue-table">
                              {" "}
                              {item?.public === false ? "Private" : "Public"}
                            </h3>
                            <img
                              src={privateLock}
                              className="img-lock"
                              alt="My Lists"
                            />
                          </div>
                        </Box>
                      </Box>
                      {/* Owner */}
                      <Box
                        sx={{
                          textAlign: "left",
                        }}
                      >
                        <Typography sx={labelStyle}>Owner</Typography>
                        <Typography sx={valueStyle}>
                          {item?.username || "-"}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Actions */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        mt: "4px",
                      }}
                    >
                      <span className="threeDotIcon-table-profile">
                        <img src={Delete} alt="" />
                      </span>
                      <span
                        className="threeDotIcon-table-profile"
                        onClick={() => handleStarClick(item)}
                      >
                        {item?.default ? (
                          <img src={selectedstar} alt="" />
                        ) : (
                          <img src={unselectedstar} alt="" />
                        )}
                      </span>
                      <span className="threeDotIcon-table-profile">
                        <img src={greypencil} alt="" />
                      </span>
                    </Box>
                  </Box>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className="ai-leads-table-main">
            <div className="ai-leads-no-data-available-outter">
              <div className="ai-leads-no-data-available">
                No Data Available
              </div>
            </div>
          </div>
        )
      ) : leadsProfileData.length > 0 ? (
        <TableContainer component={Paper} className="leads-profile-table-main">
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead className="leads-profilethead">
              <TableRow>
                <TableCell className="checkbox-row-table-inner checkbox-row-table">
                  <div className="kjhgf">
                    <input
                      type="checkbox"
                      onChange={(e) => setRowsSelectAll(e?.target?.checked)}
                      checked={rowsSelectAll}
                    />
                  </div>
                </TableCell>
                <TableCell className="cell-profile-name">
                  Profile Name
                </TableCell>
                <TableCell align="left" className="cell-created-on">
                  Created On
                </TableCell>
                <TableCell align="left" className="cell-created-on">
                  Privacy Status
                </TableCell>
                <TableCell align="left" className="cell-created-on">
                  Owner
                </TableCell>
                <TableCell align="left" className="cell-status"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="leads-profile-tablebody">
              {leadsProfileData?.map((item, index) => (
                <TableRow
                  className="table-row-leadsprofile"
                  key={item.key}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell className="checkbox-row-table-inner checkbox-row-table">
                    <div className="kjhgf">
                      <input
                        type="checkbox"
                        onChange={() => handleRowSelect(item)}
                        checked={selectedOuterRows.some(
                          (i) => i.id === item?.id,
                        )}
                      />
                    </div>
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    onClick={() =>
                      navigate(AI_PROFILE_FORM_TABLE, {
                        state: { data: item, disableFields: true },
                      })
                    }
                  >
                    {item.name ? item.name : "-"}
                  </TableCell>
                  <TableCell
                    align="left"
                    onClick={() =>
                      navigate(AI_PROFILE_FORM_TABLE, {
                        state: { data: item, disableFields: true },
                      })
                    }
                  >
                    {moment(item?.created_at).format("YYYY-MM-DD")}
                  </TableCell>
                  <TableCell align="left">
                    <div className="privacy-status-tr">
                      <h3 className="annual-revenue-table">
                        {" "}
                        {item?.public === false ? "Private" : "Public"}
                      </h3>
                      <img
                        src={privateLock}
                        className="img-lock"
                        alt="My Lists"
                      />
                    </div>{" "}
                  </TableCell>
                  <TableCell align="left">
                    <h3 className="employee-size-table">
                      {item?.username ? item?.username : "-"}
                    </h3>
                  </TableCell>
                  <TableCell align="right" className="three-dot-cell">
                    <span className="threeDotIcon-table-profile">
                      <img src={Delete} alt="" />
                    </span>
                    <span
                      className="threeDotIcon-table-profile"
                      onClick={() => handleStarClick(item)}
                    >
                      {item?.default ? (
                        <img src={selectedstar} alt="" />
                      ) : (
                        <img src={unselectedstar} alt="" />
                      )}
                    </span>
                    <span className="threeDotIcon-table-profile">
                      <img src={greypencil} alt="" />
                    </span>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <div className="ai-leads-table-main">
          <div className="ai-leads-no-data-available-outter">
            <div className="ai-leads-no-data-available">No Data Available</div>
          </div>
        </div>
      )}
    </>
  );
}
